import cmsSettings from '../cmsSettings'
import imageAsset from '../imageAsset'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title,
  images[]{${imageAsset.fields}}
`

export const fragment = (name = 'lifestyleGallery') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
